import Axios from 'axios'

const BASE_URL_V3 = `${process.env.REACT_APP_API_URL}/api/v3/`

const BASE_URL_V3_1 = `${process.env.REACT_APP_API_URL}/api/v3.1/`

// Authentication
export function signIn(data) {
  const url = BASE_URL_V3 + '/login'

  return Axios.post(url, data)
}

export function validateSession(token) {
  const url = BASE_URL_V3 + 'validateSession'

  return Axios.post(url, {}, getConfig(token))
}

export function validateSignUpCode(data) {
  const url = BASE_URL_V3 + 'validateSignUpCode'

  return Axios.post(url, data)
}

export function getSelf(token) {
  const url = BASE_URL_V3_1 + 'users'

  return Axios.get(url, getConfig(token))
}

// Users routes
export function createUser(data) {
  const url = BASE_URL_V3_1 + 'users'

  return Axios.post(url, data)
}

export function updateUser(token, data) {
  const url = BASE_URL_V3 + 'users'
  return Axios.patch(url, data, getConfig(token))
}

export function deleteAccount(token, data) {
  const url = BASE_URL_V3 + 'users/account'
  return Axios.delete(url, { ...getConfig(token), data })
}

export function resetPassword(data) {
  const url = BASE_URL_V3 + 'resetPasswordEmail'

  return Axios.post(url, data)
}

// Error report routes
export function createErrorReportConversation(token, data) {
  const url = BASE_URL_V3 + 'users/errorReportConversations'

  return Axios.post(url, data, getConfig(token))
}

export function updateConversation(token, conversationId, data) {
  const url = BASE_URL_V3 + 'users/errorReportConversations/' + conversationId

  return Axios.patch(url, data, getConfig(token))
}

// Feed routes
export function createLike(token, postId) {
  const url = BASE_URL_V3 + 'users/posts/' + postId + '/likes'

  return Axios.post(url, {}, getConfig(token))
}

export function deleteLike(token, postId) {
  const url = BASE_URL_V3 + 'users/posts/' + postId + '/likes'

  return Axios.delete(url, getConfig(token))
}

export function createComment(token, postId, data) {
  const url = BASE_URL_V3 + 'users/posts/' + postId + '/comments'

  return Axios.post(url, data, getConfig(token))
}

export function deleteComment(token, postId, commentId) {
  const url = BASE_URL_V3 + 'users/posts/' + postId + '/comments/' + commentId

  return Axios.delete(url, getConfig(token))
}

export function createPost(token, communityId, data) {
  const url = BASE_URL_V3 + 'admins/communities/' + communityId + '/posts'

  return Axios.post(url, data, getConfig(token))
}

export function deletePost(token, communityId, postId) {
  const url =
    BASE_URL_V3 + '/admins/communities/' + communityId + '/posts/' + postId

  return Axios.delete(url, getConfig(token))
}

export function sendErrorReportEmail(token, data) {
  const url = BASE_URL_V3 + 'users/errorReportMails'

  return Axios.post(url, data, getConfig(token))
}

// Booking systems
export function getBookingSystems(token) {
  const url = BASE_URL_V3 + 'users/bookingSystems'

  return Axios.get(url, getConfig(token))
}

export function getBookingSystem(token, systemId) {
  const url = BASE_URL_V3 + 'users/bookingSystems/' + systemId

  return Axios.get(url, getConfig(token))
}

export function createBookingForBookingSystem(token, systemId, data) {
  const url = BASE_URL_V3 + 'users/bookingSystems/' + systemId + '/bookings'

  return Axios.post(url, data, getConfig(token))
}

export function deleteBookingForBookingSystem(token, systemId, bookingId) {
  const url =
    BASE_URL_V3 + 'users/bookingSystems/' + systemId + '/bookings/' + bookingId

  return Axios.delete(url, getConfig(token))
}

// Booking subscriptions
export function subscribeToBooking(bookingId, token) {
  const url = BASE_URL_V3 + 'users/bookings/' + bookingId + '/subscriptions'

  return Axios.post(url, {}, getConfig(token))
}

export function unsubscribeToBooking(bookingId, token) {
  const url = BASE_URL_V3 + 'users/bookings/' + bookingId + '/subscriptions'

  return Axios.delete(url, getConfig(token))
}

// Create association
export function emailIsUnique(data) {
  const url = BASE_URL_V3 + 'emailIsUnique'

  return Axios.post(url, data)
}

export function createCorporation(data) {
  const url = BASE_URL_V3 + 'corporations'

  return Axios.post(url, data)
}

// Laundry routes
export function getLaundrySystem(token) {
  const url = BASE_URL_V3_1 + 'users/laundrySystems'

  return Axios.get(url, getConfig(token))
}

export function makeBooking(token, data) {
  const url = BASE_URL_V3_1 + 'users/laundryBookings'

  return Axios.post(url, data, getConfig(token))
}

export function deleteBooking(token, bookingId) {
  const url = BASE_URL_V3 + 'users/bookings/' + bookingId

  return Axios.delete(url, getConfig(token))
}

// Community Information routes
export function getCommunityInformation(token) {
  const url = BASE_URL_V3 + 'users/communityInformations'

  return Axios.get(url, getConfig(token))
}

// Posts
export function getPosts(token) {
  const url = BASE_URL_V3 + 'users/posts'

  return Axios.get(url, getConfig(token))
}

function getConfig(token) {
  return { headers: { authorization: 'Bearer ' + token } }
}



// WEBPACK FOOTER //
// ./src/actions/api/index.js